'use client';

import { signoutWithRedirect } from '@/app/api/server-actions/signout';
import { Button, Spinner } from '@venienergygroup/shared-components';
import { LogOutIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { ComponentProps, FC, useTransition } from 'react';

export const SignoutButton: FC<ComponentProps<typeof Button>> = ({ children, ...rest }) => {
  const [isPendingSignout, startTransition] = useTransition();
  return (
    <Button
      variant="outline"
      onClick={() =>
        startTransition(async () => {
          await signoutWithRedirect();
        })
      }
      {...rest}
    >
      {isPendingSignout ? <Spinner size="extraSmall" /> : <LogOutIcon />}
      {children}
    </Button>
  );
};

export const SignoutButtonLocalized: FC<ComponentProps<typeof Button>> = (props) => {
  const t = useTranslations('UserProfilePage');
  return <SignoutButton {...props}>{t('signOut')}</SignoutButton>;
};
